import React, { memo, useState } from 'react'
import { Button, Input } from 'src/components'
import { CircularProgress, IconButton } from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import { useForm, Controller } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useAuth } from 'src/contexts/auth'
import { toast } from 'react-toastify'
import { VALIDATIONS } from 'src/@types/validations'
import { ChangePasswordDto } from 'src/dto/user.dto'
import { useChangePassword } from 'src/hooks/api/user'
import { useStyles } from '../../styles'

interface PopupContentProps {
  onClose: () => void
}

const ChangePasswordComponent: React.FC<PopupContentProps> = ({ onClose }) => {
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false)
  const { username } = useAuth()
  const style = useStyles()

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(VALIDATIONS.User.changePasswordSchema),
    defaultValues: {
      username: username!,
      adminUsername: username!,
      senha: '',
      confirmSenha: ''
    }
  })

  const { mutateAsync: changePassword, isPending: isLoadingChangingPassword } = useChangePassword()

  const onSubmit = async (formData: ChangePasswordDto & { confirmSenha: string }) => {
    try {
      await changePassword(formData)

      toast.success('Senha alterada com sucesso!')
      onClose()
    } catch (error: unknown) {
      console.error(error)
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset>
          <ul>
            <li className={style.perfilFormItem}>
              <Controller
                name='senha'
                control={control}
                render={({ field }) => (
                  <div style={{ position: 'relative' }}>
                    <Input
                      {...field}
                      label='Nova senha:'
                      placeholder='Digite a nova senha'
                      id='newPassword'
                      type={showPassword ? 'text' : 'password'}
                      onChange={field.onChange}
                      value={field.value}
                      error={errors.senha?.message}
                    />
                    <IconButton
                      aria-label='toggle password visibility'
                      onClick={() => setShowPassword((show) => !show)}
                      className={style.popupChangePasswordIcon}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </div>
                )}
              />
            </li>

            <li className={style.perfilFormItem}>
              <Controller
                name='confirmSenha'
                control={control}
                render={({ field }) => (
                  <div style={{ position: 'relative' }}>
                    <Input
                      {...field}
                      label='Confirmar nova senha:'
                      placeholder='Repetir a nova senha'
                      id='confirmPassword'
                      type={showConfirmPassword ? 'text' : 'password'}
                      onChange={field.onChange}
                      value={field.value}
                      error={errors.confirmSenha?.message}
                    />
                    <IconButton
                      aria-label='toggle password visibility'
                      onClick={() => setShowConfirmPassword((show) => !show)}
                      className={style.popupChangePasswordIcon}
                    >
                      {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </div>
                )}
              />
            </li>
          </ul>
          <div className={style.customButtonContainer}>
            <Button type='button' outlined onClick={onClose} disabled={isLoadingChangingPassword}>
              Cancelar
            </Button>
            <Button type='submit' disabled={isLoadingChangingPassword}>
              {isLoadingChangingPassword ? <CircularProgress size={22} style={{ color: '#fff' }} /> : 'Alterar'}
            </Button>
          </div>
        </fieldset>
      </form>
    </>
  )
}

export default memo(ChangePasswordComponent)
